import { useTranslation } from 'react-i18next';

import { CommentSearchResult } from '@/shared/components/comments/CommentSearchResult';
import type { SearchResult, SearchResultHighlights } from '@/shared/registry/types';

/**
 * A comment of a task in the global search results (entity type `comment`; meta: taskId, taskTitle, number, authorName,
 * isResult). It has the visibility of its task; the row opens the task.
 */
export function TaskCommentSearchResult({
  result,
  highlights,
}: {
  result: SearchResult;
  highlights?: SearchResultHighlights;
}) {
  const { t } = useTranslation('tasks');
  const meta = result.meta ?? {};
  const title = `${meta.number ? `#${meta.number} ` : ''}${meta.taskTitle ?? ''}`.trim();
  const heading = meta.isResult ? t('search.resultOnTask', { title }) : t('search.commentOnTask', { title });
  return <CommentSearchResult result={result} highlights={highlights} heading={heading} />;
}
